export enum ROUTES {
  HOME = '/',
  BOTS = '/bots',
}
